// Shared row helper for option presets: option endpoints answer either
// JSON:API rows (`attributes` envelope) or flat rows (`should_serialize=false`).
export type JsonApiRow = { id?: string | number; attributes?: Record<string, any> };

export const attrs = (row: JsonApiRow) => row?.attributes ?? (row as Record<string, any>) ?? {};
